import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Icons } from '@/js/libs/ui';

import { Arrow } from './styles';
import { useDraggablePosition } from './useDraggablePosition';

interface IScrollTop {
  offset: number;
}

const ScrollArrow: React.FC<IScrollTop> = ({ offset }) => {
  const [showScroll, setShowScroll] = React.useState<boolean>(false);

  const checkScroll = useCallbackRef(() => {
    if (!showScroll && window.scrollY > offset) {
      setShowScroll(true);
    } else if (showScroll && window.scrollY <= offset) {
      setShowScroll(false);
    }
  });

  const scrollTop = useCallbackRef(() => {
    window.scrollTo({ top: 0 });
  });

  const { ref, positionCss, isDragging, handlers } = useDraggablePosition({ onActivate: scrollTop });

  React.useEffect(() => {
    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, [checkScroll]);

  return (
    <CSSTransition in={showScroll} transitionAppear transitionAppearTimeout={500} timeout={150} unmountOnExit>
      <Arrow ref={ref} $visible={showScroll} $position={positionCss} $dragging={isDragging} {...handlers}>
        <Icons.Angle alt direction='top' />
      </Arrow>
    </CSSTransition>
  );
};

export default ScrollArrow;
